import { useState, useEffect } from 'react';
import api from '../services/api';

export default function Anexos({ clienteId, atividadeId }) {
  const [anexos, setAnexos] = useState([]);
  const [temas, setTemas] = useState([]);
  const [temaSelecionado, setTemaSelecionado] = useState('');
  const [uploading, setUploading] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    carregar();
    carregarTemas();
  }, [clienteId, atividadeId]);

  async function carregar() {
    try {
      const url = atividadeId
        ? `/anexos/atividade/${atividadeId}`
        : `/anexos/cliente/${clienteId}`;
      const res = await api.get(url);
      setAnexos(res.data);
    } catch (err) {
      console.error('Erro ao carregar anexos', err);
    }
  }

  async function carregarTemas() {
    try {
      const res = await api.get('/parametros/tema_documento');
      setTemas(res.data.map(t => t.valor).filter(t => t !== 'Outros'));
    } catch {
      setTemas(['Contrato', 'Procuração', 'Documento Pessoal', 'Ato Societário', 'Comprovante', 'NF-e', 'Boleto']);
    }
  }

  async function upload(e) {
    const arquivo = e.target.files[0];
    if (!arquivo) return;
    if (!temaSelecionado) {
      alert('Selecione o tipo de documento antes de anexar!');
      e.target.value = '';
      return;
    }
    setUploading(true);
    setErro('');
    try {
      const formData = new FormData();
      formData.append('arquivo', arquivo);
      formData.append('cliente_id', clienteId);
      formData.append('tema', temaSelecionado);
      if (atividadeId) formData.append('atividade_id', atividadeId);
      await api.post('/anexos/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      carregar();
    } catch (err) {
      setErro('Erro ao fazer upload. Tente novamente.');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  }

  async function download(anexo) {
    try {
      const res = await api.get(`/anexos/${anexo.id}/download`);
      window.open(res.data.url, '_blank');
    } catch {
      alert('Erro ao baixar arquivo.');
    }
  }

  async function deletar(id) {
    if (!window.confirm('Remover este anexo?')) return;
    await api.delete(`/anexos/${id}`);
    carregar();
  }

  function formatarData(dt) {
    if (!dt) return '—';
    return new Date(dt).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  function iconeArquivo(nome) {
    const ext = nome.split('.').pop().toLowerCase();
    if (['pdf'].includes(ext)) return '📄';
    if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) return '🖼️';
    if (['doc', 'docx'].includes(ext)) return '📝';
    if (['xls', 'xlsx'].includes(ext)) return '📊';
    return '📎';
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.titulo}>📎 Anexos</span>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <select style={styles.selectTema} value={temaSelecionado} onChange={e => setTemaSelecionado(e.target.value)}>
            <option value="">Selecione o tipo...</option>
            {temas.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          <label style={styles.botaoUpload}>
            {uploading ? 'Enviando...' : '+ Anexar'}
            <input type="file" style={{ display: 'none' }} onChange={upload} disabled={uploading} />
          </label>
        </div>
      </div>
      {erro && <p style={styles.erro}>{erro}</p>}
      {anexos.length === 0 ? (
        <p style={styles.vazio}>Nenhum anexo</p>
      ) : (
        <div style={styles.lista}>
          {anexos.map(a => (
            <div key={a.id} style={styles.item}>
              <span style={styles.icone}>{iconeArquivo(a.nome_arquivo)}</span>
              <div style={styles.info}>
                <span style={styles.nome}>{a.nome_arquivo}</span>
                <span style={styles.meta}>{a.tema} · {a.enviado_por} · {formatarData(a.criado_em)}</span>
              </div>
              <div style={styles.acoes}>
                <button style={styles.botaoBaixar} onClick={() => download(a)}>⬇ Baixar</button>
                <button style={styles.botaoDeletar} onClick={() => deletar(a.id)}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { marginTop: '1rem', backgroundColor: '#f9f9f9', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '1rem' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' },
  titulo: { fontSize: '13px', fontWeight: '600', color: '#1a1a2e' },
  selectTema: { padding: '4px 8px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '12px' },
  botaoUpload: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
  erro: { color: '#e53935', fontSize: '12px', marginBottom: '8px' },
  vazio: { fontSize: '12px', color: '#aaa', textAlign: 'center', padding: '1rem 0' },
  lista: { display: 'flex', flexDirection: 'column', gap: '6px' },
  item: { display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: '#fff', border: '1px solid #eee', borderRadius: '6px', padding: '8px 12px' },
  icone: { fontSize: '18px' },
  info: { flex: 1, display: 'flex', flexDirection: 'column' },
  nome: { fontSize: '13px', color: '#1a1a2e', fontWeight: '500' },
  meta: { fontSize: '11px', color: '#888', marginTop: '2px' },
  acoes: { display: 'flex', gap: '6px' },
  botaoBaixar: { backgroundColor: 'transparent', color: '#1976d2', border: '1px solid #1976d2', padding: '3px 10px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' },
  botaoDeletar: { backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '3px 8px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' },
};